/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { Typography2 } from '@coursera/cds-core';
import { CheckIcon } from '@coursera/cds-icons';

import { getCourseIncludeListItems, getGlanceItems } from 'bundles/collections/constants';

import 'css!bundles/collections/components/__styles__/AtGlance';

const styles = {
  glanceItems: css`
    flex-direction: column;
    display: flex;
    margin-bottom: 3rem;
    align-items: center;
  `,
  glanceItemText: css`
    text-align: center;
    max-width: 168px;
  `,
  glanceImage: css`
    margin-bottom: 1rem;
  `,
  freeTrialText: css`
    background-color: #f5f5f5;
  `,
};

const AtGlance = () => {
  const glanceItems = getGlanceItems();
  const courseIncludeItems = getCourseIncludeListItems();
  return (
    <div>
      {glanceItems.map((item) => (
        <div css={styles.glanceItems} key={item.alt}>
          <Imgix src={item.icon} maxWidth={45} css={styles.glanceImage} alt={item.alt} />
          <Typography2 variant="bodyPrimary" component="span" css={styles.glanceItemText}>
            {item.text}
          </Typography2>
        </div>
      ))}
      <div className="p-x-1 p-y-2">
        <Typography2 component="span" variant="subtitleMedium">
          All courses include:
        </Typography2>
        <ul className="list-style-none p-l-0">
          {courseIncludeItems.map((item) => (
            <li className="horizontal-box m-t-1" key={item}>
              <Typography2 component="span" className="m-r-1">
                <CheckIcon size="medium" color="interactive" />
              </Typography2>
              <Typography2 component="span" variant="bodyPrimary">
                {item}
              </Typography2>
            </li>
          ))}
        </ul>
      </div>
      <div css={styles.freeTrialText} className="m-y-2 p-y-2 p-x-1">
        <Typography2 component="p" variant="subtitleMedium" className="m-b-1s">
          Can’t decide what is right for you?
        </Typography2>
        <Typography2 component="span" variant="bodyPrimary">
          Try the full learning experience for most courses free for 7 days.
        </Typography2>
      </div>
    </div>
  );
};

export default AtGlance;
